export const parseLinksToAbsolute = (html: string): string => {
    if (!html) return '';
    //find href links that do not start with http
    const parsed = html.replace(/(<a href="(?!http))/g, '<a href="http://');
    return parsed;
};
